import {
  Home,
  FolderKanban,
  Briefcase,
  TrendingUp,
  FileText,
  ChartNoAxesCombined,
  BarChart3,
  Users,
  Calendar,
  Settings,
  FolderOpen,
  BookUser,
  BadgeInfo,
  FileBarChart,
  ClipboardList,
  FolderTree,
  GraduationCap,
  Activity,
} from "lucide-react";
import type { MenuItem } from "../types";

/**
 * Menu Items Configuration
 * Define your menu structure here based on Discovery analysis
 */
export const menuItems: MenuItem[] = [
  // Main Group
  { id: "dashboard", label: "Homepage", icon: Home, page: "dashboard" },
  { id: "projects", label: "Projects", icon: FolderKanban, page: "projects" },
  { id: "project-templates", label: "Project Templates", icon: FolderTree, page: "project-templates" },
  { id: "portfolio", label: "Portfolio", icon: Briefcase, page: "portfolio" },
  
  // Resources Group (with sub-menu)
  { 
    id: "resources-menu", 
    label: "Resources", 
    icon: FolderOpen, 
    page: "resources-menu",
    children: [
      { id: "directory", label: "Directory", icon: BookUser, page: "directory" },
      { id: "roles-rates", label: "Roles & Rates", icon: BadgeInfo, page: "roles-rates" },
      { id: "resources", label: "Resource Allocation", icon: Users, page: "resources" },
      { id: "utilisation", label: "Utilisation", icon: TrendingUp, page: "utilisation" },
      { id: "skills", label: "Skills", icon: GraduationCap, page: "skills" },
    ]
  },
  
  // Reports Group (with sub-menu)
  { 
    id: "reports-menu", 
    label: "Reports", 
    icon: FileBarChart, 
    page: "reports-menu",
    children: [
      { id: "project-transactions", label: "Project Transactions", icon: ClipboardList, page: "project-transactions" },
      { id: "wip-reporting", label: "WIP", icon: FileText, page: "wip-reporting", tooltip: "Work In Progress" },
      { id: "project-status", label: "Project Status", icon: Activity, page: "project-status", tooltip: "Operational Reports" },
      { id: "budget-variance", label: "Budget Variance", icon: BarChart3, page: "budget-variance", tooltip: "Financial Reports" },
      { id: "project-pl", label: "Project P&L", icon: TrendingUp, page: "project-pl", tooltip: "Financial Reports" },
      { id: "project-forecast", label: "Project Forecast", icon: BarChart3, page: "project-forecast", tooltip: "Financial Reports" },
      { id: "profitability", label: "Profitability Analysis", icon: ChartNoAxesCombined, page: "profitability", tooltip: "Financial Reports" },
      { id: "audit-log", label: "Audit Log", icon: FileBarChart, page: "audit-log" },
    ]
  },

  
  // Planning Group
  { id: "gantt", label: "Gantt Charts", icon: Calendar, page: "gantt" },
];

/**
 * Database Options Configuration
 * Not used - company selector remains in header
 */
export const databases = [];

/**
 * Menu Configuration
 */
export const menuConfig = {
  /** Total number of pages (16 main pages including sub-menu items) */
  totalPages: 16,
  /** Minimum pages required to enable favorites feature */
  favoritesThreshold: 10,
  /** Show database switcher in footer - NO (company selector in header) */
  showDatabaseSwitcher: false,
  /** Show settings button in footer - YES (Settings in footer with sub-menu) */
  showSettings: true,
};
